import { ChevronUpIcon, ChevronDownIcon } from "@heroicons/react/outline";

export interface SortIndicatorProps {
  active: boolean;
  direction: "asc" | "desc";
}

const SortIndicator = ({ active, direction }: SortIndicatorProps) => {
  if (!active) {
    return <ChevronDownIcon className="w-4 h-4" style={{ stroke: "#00C889", opacity: 0.3 }} />;
  }
  return direction === "asc" ? (
    <ChevronUpIcon className="w-4 h-4" style={{ stroke: "#00C889" }} />
  ) : (
    <ChevronDownIcon className="w-4 h-4" style={{ stroke: "#00C889" }} />
  );
};

export default SortIndicator;
